
function showDiscountError(message) {
  const el = document.createElement('div')
  el.className = 'discount-error-view'
  el.innerText = message
  el.innerHTML = `
    <div class="discount-error">${message}</div>
  `;
  document.body.appendChild(el);
  setTimeout(() => el.classList.add('show'), 10);
  setTimeout(() => {
    el.classList.remove('show');
    setTimeout(() => el.remove(), 300);
  }, 3000);
}

// DOM元素
const triggerIcon = document.getElementById('triggerIcon');
const listModal = document.getElementById('listModal');
const listModalClose = document.getElementById('listModalClose');
const couponList = document.getElementById('couponList');
const copyToast = document.getElementById('copyToast');
const toastMessage = document.getElementById('toastMessage');
const noCoupons = document.getElementById('noCoupons');       

let currentFilter = 'all';

async function apiRequest(url, options = {}) {
  const {
    method = 'GET',
    token = '',
    data = {},
  } = options;
  
  try {
    const config = {
      method: method,
    };
    
    // 如果是 POST/PUT/PATCH，添加请求体
    if (['POST', 'PUT', 'PATCH'].includes(method.toUpperCase())) {
      config.body = JSON.stringify(data);
    }

    const response = await fetch(url, config);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const result = await response.json();
    return result;
    
  } catch (error) {
    throw error;
  }
}

// 使用示例
const token = requestConfig.api_token;
// 创建 URL 参数对象
const params = new URLSearchParams({
  access_token: token,
  ...customerFromLiquid
});

const getCouponListUrl = `${requestConfig.target}${requestConfig.get_coupon_list}?${params.toString()}`;
const getShopiftGiftCardsUrl = `${requestConfig.target}${requestConfig.get_shopift_gift_cards}?${params.toString()}`;

// 格式化日期函数
function formatDate(dateString) {
  if (!dateString) return "无期限";
  
  const date = new Date(dateString);
  return date.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}

// 获取到期状态
function getExpiryStatus(expiresOn) {
  if (!expiresOn) return { text: "", class: "expiry-normal" };
  
  const expiryDate = new Date(expiresOn);
  const today = new Date();
  const diffTime = expiryDate - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays < 0) {
    return { text: "已过期", class: "expiry-expired" };
  } else if (diffDays <= 7) {
    return { text: `${diffDays}天后到期`, class: "expiry-soon" };
  } else {
    return { text: formatDate(expiresOn), class: "expiry-normal" };
  }
}

// 格式化货币
function formatCurrency(amount, currency) {
  return `${currency} ${parseFloat(amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

// 渲染礼品卡列表
function renderGiftCards(giftCards) {
  const noGiftCards = document.getElementById('no-gift-cards');
  const container = document.getElementById('shopift-gift-cards');
  const giftCardHeaderTitle = document.querySelector('#gift-card-header .discount-list-title h5');
  if (giftCardHeaderTitle && giftCards.length) {
    giftCardHeaderTitle.innerText = 'Gift Card 礼品卡' + `(${giftCards.length})`;
  }

  if (!giftCards.length) {
    noGiftCards.classList.remove('hidden')
  }

  container.innerHTML = '';
  
  // 排序：将余额为0的放到后面
  const sortedCards = [...giftCards].sort((a, b) => {
    const balanceA = parseFloat(a.current_balance);
    const balanceB = parseFloat(b.current_balance);
    
    // 如果余额都为0，保持原顺序
    if (balanceA === 0 && balanceB === 0) return 0;
    // 如果a余额为0，b不为0，则a应该排在后面
    if (balanceA === 0 && balanceB > 0) return 1;
    // 如果a余额不为0，b为0，则a应该排在前面
    if (balanceA > 0 && balanceB === 0) return -1;
    
    // 默认保持原顺序
    return 0;
  });
  
  sortedCards.forEach(card => {
    const balance = parseFloat(card.current_balance);
    const initial_balance = parseFloat(card.initial_balance);
    const expiryStatus = getExpiryStatus(card.expires_on);
    const createDate = formatDate(card.create_date);
    const isZeroBalance = balance === 0;
    
    const cardElement = document.createElement('div');
    cardElement.className = `grit-cards-view ${isZeroBalance ? 'empty-balance' : ''}`;
    
    cardElement.innerHTML = `
      <div class="grit-card">
        <div class="grit-card-header">
          <span class="card-logo-name">NewFresh</span>
          <span class="card-name">礼品卡 Grit Card</span>
        </div>
        <div class="grit-card-content">
          <b class="grit-card-code">${card.name}</b>
        </div>
        <div class="grit-card-balance">
          <div class="grit-card-expired">
            <span>${expiryStatus.text}</span>
          </div>
          <div class="grit-card-amount">
            <div class="balance">
              <span class="unit">${card.currency}</span>
              <b class="price">${balance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
            </div>
            <span class="old-balance">Initial Balance: ${card.currency} ${initial_balance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
          </div>
      </div>
    `;
      
    container.appendChild(cardElement);
  });
  // updateStats(giftCards);
}

// 初始化
function init() {
  const discountList = document.getElementById('discount-list');
  if (customerFromLiquid.id && discountList) {
    renderCoupons();
    initToggleSections();
  }
  setupEventListeners();
  const lastCode = sessionStorage.getItem('last_discount_try')
  if (!lastCode) return

  if (!appliedDiscounts.find((dis) => String(dis.title).toLowerCase() === String(lastCode).toLowerCase())) {
    showDiscountError(
      `优惠码 ${lastCode} 不符合使用条件`
    )
  }

  sessionStorage.removeItem('last_discount_try')
}

// 生成优惠券卡片
function renderCoupons(type = 'all') {

  const cachedDiscountLists = sessionStorage.getItem('discountLists');
  const cachedDiscountCards = sessionStorage.getItem('discountCards');
  if ((cachedDiscountLists || cachedDiscountCards) && type === 'cached') {
    renderDiscountList(JSON.parse(cachedDiscountLists));
    renderGiftCards(JSON.parse(cachedDiscountCards));
    return;
  }

  apiRequest(getCouponListUrl, {
    method: 'GET',
    data: {
      ...customerFromLiquid,
    }
  }).then(data => {
    // 转换函数：将Ruby哈希格式转换为JSON
    function rubyHashToJSON(rubyHashString) {
      // 将 => 替换为 :
      let jsonString = rubyHashString.replace(/=>/g, ':');
      // 处理键名（确保有引号）
      jsonString = jsonString.replace(/(\w+):/g, '"$1":');
      return JSON.parse(jsonString);
    }
    const filteredCoupons = (data || []).map((item) => ({
      ...item,
      desc: item.summary.replace(/\s*•\s*For.*$/, '').replace(/\$/g, 'SGD'),
      customerGets: rubyHashToJSON(item.customerGets),
      minimumRequirement: item.minimumRequirement ? rubyHashToJSON(item.minimumRequirement) : null,
    }));

    noCoupons.style.display = 'none';
    sessionStorage.setItem('discountLists', JSON.stringify(filteredCoupons));
    renderDiscountList(filteredCoupons)
  }).catch(error => {
    console.error('失败:', error);
  });

  const giftCards = document.getElementById('shopift-gift-cards');
   if (giftCards && type !== 'click') {
    apiRequest(getShopiftGiftCardsUrl, {
      method: 'GET',
      data: {
        ...customerFromLiquid,
      }
    }).then(data => {
     console.log('礼品卡', data);
      sessionStorage.setItem('discountCards', JSON.stringify(data));
     renderGiftCards(data);
    }).catch(error => {
      console.error('失败:', error);
    });
  }
}

// 切换展开/收缩功能
function initToggleSections() {
  const discountHeader = document.getElementById('discount-header');
  const giftCardHeader = document.getElementById('gift-card-header');
  const discountContent = document.getElementById('discount-content');
  const giftCardContent = document.getElementById('gift-card-content');
  const discountToggleIcon = document.getElementById('discount-toggle-icon');
  const giftCardToggleIcon = document.getElementById('gift-card-toggle-icon');
  console.log('discountHeader', discountHeader);
  
  if (discountHeader) {
    // 优惠券部分切换
    discountHeader.addEventListener('click', function() {
      discountContent.classList.toggle('collapsed');
      if (discountContent.classList.contains('collapsed')) {
        discountToggleIcon.className = 'fas fa-chevron-up toggle-icon';
      } else {
        discountToggleIcon.className = 'fas fa-chevron-down toggle-icon';
      }
    });
  }
  
  if (giftCardHeader) {
    // 礼品卡部分切换
    giftCardHeader.addEventListener('click', function() {
      giftCardContent.classList.toggle('collapsed');
      if (giftCardContent.classList.contains('collapsed')) {
        giftCardToggleIcon.className = 'fas fa-chevron-up toggle-icon';
      } else {
        giftCardToggleIcon.className = 'fas fa-chevron-down toggle-icon';
      }
    });
  }
  
  if (giftCardContent) {
    giftCardContent.classList.add('collapsed');
  }
  if (giftCardToggleIcon) {
    giftCardToggleIcon.className = 'fas fa-chevron-up toggle-icon';
  }
  // 初始状态：优惠券部分展开，礼品卡部分收缩
}

function renderDiscountList(lists) {
  const noCoupons = document.getElementById('no-coupons');
  const _noCoupons = document.getElementById('noCoupons');
  const discountGridList = document.getElementById('coupon-grid-list');
  const discountHeaderTitle = document.querySelector('#discount-header .discount-list-title h5');
  const activeLists = lists.filter((list) => list.status === 'ACTIVE');
  if (discountHeaderTitle && activeLists.length) {
    discountHeaderTitle.innerText = 'Coupon list 优惠券列表' + `(${activeLists.length})`;
  }
  if (!activeLists.length) {
    if (noCoupons) {
      noCoupons.classList.remove('hidden');
    }
    if (noCoupons) {
      _noCoupons.classList.remove('hidden');
    }
  }
  if (lists.length === 0) {
    noCoupons.style.display = 'block';
    return;
  }
  triggerIcon.classList.remove('hide');
  couponList.innerHTML = '';
  if (discountGridList) {
    discountGridList.innerHTML = '';
  }
  lists.forEach(coupon => {
    const selectEd = appliedDiscounts.find((dis) =>  
      String(coupon.code).toLowerCase() === String(dis.title).toLowerCase()
    );
    
    // 创建卡片
    const createCard = () => {
      const couponCard = document.createElement('div');
      let status = coupon.status;
      couponCard.className = 'coupon-card';
      
      let cardContentClass= 'coupon-card-content';
      // 添加特殊样式类
      if (isExpiringSoon(coupon.endsAt)) {
        cardContentClass += ' expiring';
        couponCard.classList.add('expiring');
      }
      if (selectEd) {
        cardContentClass += ' featured';
      }
      const limit = coupon.usagelimit - coupon.asyncusagecount;
      const copyBtnClass = `copy-btn ${selectEd ? 'disabled' : ''}`;
      if (limit > 1) {
        couponCard.classList.add('limits');
        couponCard.innerHTML = `<div class="coupon-limit">x${limit} 张</div> `;
      }
      couponCard.classList.add(coupon.status);
      if (coupon.status !== 'ACTIVE') {
        couponCard.style.display = 'none';
      }
      if (limit === 0 && coupon.usagelimit) {
        status = 'used'
      }
      couponCard.dataset.status = status;
      couponCard.innerHTML += `
        <div class="${cardContentClass}">
          ${selectEd ? '<div class="badge">已使用</div>' : ''}
          ${isExpiringSoon(coupon.endsAt) ? '<div class="badge expiry-badge">即将到期</div>' : ''}
          <div class="coupon-card-price">
            ${coupon.customerGets.value.__typename === 'DiscountAmount' ? `
              <div class="customer-gets">
              <span class="price-unit">SGD</span>
              <span class="customer-amount">${coupon.customerGets.value.amount ? coupon.customerGets.value.amount.amount : ''}</span>
            </div>
            <div class="coupon-tag">满减劵</div>
            ` : ''}
            ${coupon.customerGets.value.__typename === 'DiscountPercentage' ? `
              <div class="customer-gets">
              <span class="customer-amount">${coupon.customerGets.value.percentage ? coupon.customerGets.value.percentage * 100 : ''}</span>
              <span class="price-unit">%</span>
            </div>
            <div class="coupon-tag">折扣券</div>
            `  : ''}
          </div>
          <div class="coupon-card-info">
            <div class="coupon-code">
            ${coupon.minimumRequirement ?
              `<div class="minimum-requirement">
                <span class="amount-tip-text">满</span>
                ${coupon.minimumRequirement.__typename === "DiscountMinimumQuantity" ? `<span class="amount-unit">${coupon.minimumRequirement?.greaterThanOrEqualToQuantity} 件商品</span>` : '<span class="amount-unit">SGD</span>'}
                ${coupon.minimumRequirement.__typename === "DiscountMinimumSubtotal" ? `<span class="amount">${coupon.minimumRequirement?.greaterThanOrEqualToSubtotal?.amount}</span>` : ''}
                <span class="amount-tip-text">可用</span>
              </div>` : `<div class="minimum-requirement">
                <span class="amount-tip-text">无门槛</span>
              </div>`
            }
              <button class="${copyBtnClass}" data-code="${coupon.code}" title="${coupon.code}">
                <span>${selectEd ? 'APPLIED' : 'APPLY'}</span>
              </button>
              ${status !== 'used' ? '<a href="/" class="copy-btn go-use"><span>Go use</span></a>' : ''}
            </div>
            <div class="coupon-desc">${coupon.desc}</div>
            <div class="coupon-details">
              <div class="coupon-type"></div>
              <div class="ends-at">${formatExpiry(coupon.endsAt)}</div>
            </div>
          </div>
        </div>
      `;
      return couponCard;
    };
    
    // 创建卡片1
    const couponCard1 = createCard();
    couponList.appendChild(couponCard1);
    
    // 如果discountGridList存在，创建另一个卡片
    if (discountGridList) {
      const couponCard2 = createCard();  // 重新创建，不是克隆
      discountGridList.appendChild(couponCard2);
    }
  });
  // 添加复制按钮事件
  setupCopyButtons();
}

// 检查是否即将到期
function isExpiringSoon(expiry) {
  if (expiry === null) return false;
  
  const expiryDate = new Date(expiry);
  const today = new Date();
  const timeDiff = expiryDate.getTime() - today.getTime();
  const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
  
  return daysDiff <= 30 && daysDiff >= 0;
}

// 格式化有效期显示
function formatExpiry(expiry) {
  if (expiry === null || expiry === undefined || expiry === '') {
    return '永久有效';
  }
  
  // 尝试解析日期，支持多种格式
  let expiryDate;
  if (expiry instanceof Date) {
    expiryDate = expiry;
  } else if (typeof expiry === 'string') {
    // 移除可能的时间部分
    const dateStr = expiry.split('T')[0].split(' ')[0];
    expiryDate = new Date(dateStr);
  } else {
    expiryDate = new Date(expiry);
  }
  
  // 检查日期是否有效
  if (isNaN(expiryDate.getTime())) {
    console.warn(`无效的日期格式: ${expiry}`);
    return '永久有效';
  }
  
  const today = new Date();
  today.setHours(0, 0, 0, 0); // 清除时间部分
  
  const timeDiff = expiryDate.getTime() - today.getTime();
  const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
  
  if (daysDiff < 0) {
    return '已过期';
  } else if (daysDiff === 0) {
    return '今天到期';
  } else if (daysDiff === 1) {
    return '明天到期';
  } else if (daysDiff <= 7) {
    return `${daysDiff}天后到期`;
  } else {
    // 格式化日期为 YYYY-MM-DD
    const year = expiryDate.getFullYear();
    const month = String(expiryDate.getMonth() + 1).padStart(2, '0');
    const day = String(expiryDate.getDate()).padStart(2, '0');
    return `有效期至：${year}-${month}-${day}`;
  }
}

// 设置复制按钮事件
function setupCopyButtons() {
  document.querySelectorAll('.copy-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (btn.classList.contains('disabled') || btn.classList.contains('go-use')) {
        return
      } 
      const code = btn.getAttribute('data-code');
      copyToClipboard(code, btn);
    });
  });
}
  
// 复制到剪贴板
function copyToClipboard(text, button = null) {
  const cartDiscountInput = document.getElementById('Cart__DiscountField');
  if (cartDiscountInput) {
    cartDiscountInput.value = text;
  }
  applyDiscount(text);
  // 使用现代 Clipboard API
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text)
      .then(() => {
        showCopySuccess(text, button);
      })
      .catch(err => {
        console.error('复制失败:', err);
        fallbackCopyToClipboard(text, button);
      });
  } else {
    // 回退方案
    fallbackCopyToClipboard(text, button);
  }
}

async function applyDiscount(code) {
  sessionStorage.setItem('last_discount_try', code)
  
  // 获取当前语言路径前缀（如 /zh, /en 等）
  const currentPath = window.location.pathname
  const langPrefix = currentPath.match(/^\/(zh|en|fr|de|ja|es|it|pt|nl|ko|th|vi|id|ms|ar|he|tr|pl|cs|da|fi|no|sv|ru|uk|el|ro|hu|sk|bg|hr|sl|et|lv|lt)(?=\/|$)/)
  const langPath = langPrefix ? langPrefix[0] : ''
  
  // 构建带语言前缀的跳转 URL
  window.location.href = `${langPath}/discount/${encodeURIComponent(code)}?redirect=${langPath}/cart`
}


function showMessage(message, type = 'info') {
  const messageEl = document.createElement('div');
  messageEl.className = `discount-message-tag discount-${type}`;
  messageEl.textContent = message;
  
  document.body.appendChild(messageEl);
  
  setTimeout(() => {
    messageEl.classList.add('show');
  }, 10);
  
  setTimeout(() => {
    messageEl.classList.remove('show');
    setTimeout(() => messageEl.remove(), 300);
  }, 3000);
}

// 回退复制方法
function fallbackCopyToClipboard(text, button) {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  
  try {
    document.execCommand('copy');
    showCopySuccess(text, button);
  } catch (err) {
    console.error('复制失败:', err);
    showToast('复制失败，请手动复制: ' + text, 'error');
  }
  
  document.body.removeChild(textarea);
}

// 显示复制成功效果
function showCopySuccess(text, button = null) {
  // 显示全局提示
  showToast('APPLIED: ' + text, 'success');
  
  // 如果有按钮，更新按钮状态
  if (button) {
    const originalText = button.querySelector('span')?.textContent || 'COPY';
    button.classList.add('copied');
    button.innerHTML = '<span>APPLIED</span>';
    
    // 3秒后恢复按钮状态
    setTimeout(() => {
      button.classList.remove('copied');
      button.innerHTML = `<span>${originalText}</span>`;
    }, 3000);
  }
}

// 显示提示信息
function showToast(message, type = 'success') {
  toastMessage.textContent = message;
  copyToast.classList.add('show');
  
  // 根据类型设置不同的图标
  const icon = copyToast.querySelector('.toast-icon');
  if (type === 'error') {
      icon.textContent = '✕';
      copyToast.style.background = 'rgba(244, 67, 54, 0.9)';
  } else {
      icon.textContent = '✓';
      copyToast.style.background = 'rgba(0, 0, 0, 0.8)';
  }
  
  setTimeout(() => {
      copyToast.classList.remove('show');
  }, 3000);
}
// 设置事件监听器
function setupEventListeners() {
  // 触发图标点击事件
  triggerIcon.addEventListener('click', () => {
    if (customerFromLiquid.id) {
      renderCoupons('click');
    }
    if (listModal) {
      listModal.style.display = 'flex';
    }
  });
  
  // 列表弹框关闭按钮
  listModalClose.addEventListener('click', () => {
    if (listModal) {
      listModal.style.display = 'none';
    }
  });
  
  // 点击模态框外部关闭
  window.addEventListener('click', (e) => {
    if (listModal && e.target === listModal) {
      listModal.style.display = 'none';
    }
  });
  
  
  // ESC键关闭弹框
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (listModal.style.display === 'flex') {
        listModal.style.display = 'none';
      }
    }
  });
}

// 页面加载完成后初始化
document.addEventListener('DOMContentLoaded', init);